
import i18nCommon from '@modules/i18n/mixins/Common';
import Vue, {VueConstructor} from 'vue';

export default (Vue as VueConstructor<Vue & InstanceType<typeof i18nCommon>>).extend({
  name: 'ButtonCloseModal',
  mixins: [i18nCommon],
  computed: {
    accessibleCloseModalBtnLabel(): string {
      return this.translate('modals.close');
    },
  },
});
